import { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { Typography } from '../typography';
import { Button } from '../button';
import { enqueueSnackbar } from '../snackbar';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { useIsSmallScreen, useSendContractMailerMutation } from '../../hooks';
import { MESSAGES } from '../../const';
import { i18n } from '../../i18n';

export const sendContractModal: any = {};

export const SendContractModal = () => {
  const { mutate, isLoading } = useSendContractMailerMutation();
  const [open, setOpen] = useState(false);
  const isSmallScreen = useIsSmallScreen();

  useEffect(() => {
    sendContractModal.open = () => {
      setOpen(true);

      const mutateData: any = {
        yardId: sendContractModal.yardId,
      };

      mutate(mutateData, {
        onError: () => {
          enqueueSnackbar(MESSAGES.CLIENT.ERROR.NOT_SEND_CONTRACT, 'error');
        },
      });
    };
  }, []);

  const handleOnClose = () => {
    Object.keys(sendContractModal).forEach((key) => {
      if (key !== 'open') delete sendContractModal[key];
    });
    setOpen(!open);
  };

  return (
    <ModalBase
      id={'send-contract-modal'}
      paperSize={isSmallScreen ? 'mobile' : 'default'}
      open={open}
      hideCloseIcon
    >
      <ModalWrapper>
        <Typography variant={'textM'}>{i18n.t('pages.modal.sendContractTitle')}</Typography>
        {isSmallScreen && <span />}
        <ModalFooterButtons>
          <Button
            size={'medium'}
            data-color={'primary'}
            onClick={handleOnClose}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={24} color={'inherit'} /> : i18n.t('button.ok')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
